"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const joi_1 = __importDefault(require("joi"));
const errors_1 = require("../../errors");
const IGroupingAndMinimums_1 = require("../models/rates/IGroupingAndMinimums");
class GroupingAndMinimumnsValidator {
    groupAndMinimumGroupByValues = Object.values(IGroupingAndMinimums_1.GroupAndMinimumGroupBy);
    schema = joi_1.default.object({
        groupChargesBy: joi_1.default.string()
            .valid(...this.groupAndMinimumGroupByValues)
            .optional(),
        minimumChargeAmount: joi_1.default.number().min(0).precision(2).optional(),
        applyMinimumToGroup: joi_1.default.when('groupChargesBy', {
            is: joi_1.default.exist(),
            then: joi_1.default.bool().default(false),
            otherwise: joi_1.default.bool().default(false).valid(false),
        })
            .when('minimumChargeAmount', {
            is: joi_1.default.exist(),
            then: joi_1.default.bool().default(false),
            otherwise: joi_1.default.bool().default(false).valid(false),
        })
            .required(),
    });
    validate(groupingAndMinimumns, jsonPath) {
        const result = this.schema.validate(groupingAndMinimumns, {
            abortEarly: false,
            convert: false,
        });
        if (result.error) {
            const issues = [];
            result.error.details.forEach((issue) => {
                switch (issue.type) {
                    case 'number.min':
                    case 'any.only':
                    case 'number.precision': {
                        issues.push(new errors_1.Errors.ValidationIssue('IGroupingAndMinimums', errors_1.Errors.ValidationErrorCode.invalidValue, issue.context?.key, issue.context?.value, jsonPath));
                        break;
                    }
                    case 'any.required': {
                        issues.push(new errors_1.Errors.ValidationIssue('IGroupingAndMinimums', errors_1.Errors.ValidationErrorCode.requiredValue, issue.context?.key, undefined, jsonPath));
                        break;
                    }
                    case 'string.base':
                    case 'boolean.base':
                    case 'number.base':
                    case 'object.base': {
                        issues.push(new errors_1.Errors.ValidationIssue('IGroupingAndMinimums', errors_1.Errors.ValidationErrorCode.invalidType, issue.context?.key, issue.context?.value, jsonPath));
                        break;
                    }
                }
            });
            return issues;
        }
    }
}
exports.default = GroupingAndMinimumnsValidator;
